// extracted by mini-css-extract-plugin
module.exports = {"Loading":"📚4-7-02c_Rd","Spinner":"📚4-7-01n0Q7","rotate":"📚4-7-0194NH","size_normal":"📚4-7-03SVYh","size_large":"📚4-7-0374rx","Circle":"📚4-7-01V7YV","circle-line":"📚4-7-03uJqn"};